import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CheckboxBtnComponent } from 'src/app/shared/components/dynamicElments/checkbox-btn/checkbox-btn.component';
import { DateRangeComponent } from 'src/app/shared/components/dynamicElments/date-range/date-range.component';
import { DateComponent } from 'src/app/shared/components/dynamicElments/date/date.component';
import { FilesComponent } from 'src/app/shared/components/dynamicElments/files/files.component';
import { InputsComponent } from 'src/app/shared/components/dynamicElments/inputs/inputs.component';
import { MultiselectComponent } from 'src/app/shared/components/dynamicElments/multiselect/multiselect.component';
import { RadioBtnsComponent } from 'src/app/shared/components/dynamicElments/radio-btns/radio-btns.component';
import { SelectDynamicComponent } from 'src/app/shared/components/dynamicElments/select/select.component';
import { TextareaComponent } from 'src/app/shared/components/dynamicElments/textarea/textarea.component';
import { DynamicMapComponent } from 'src/app/shared/components/dynamicElements/dynamic-map/dynamic-map.component';
import { ApiService } from '../../api/api.service';
import { SERVICES_ORDERS_ENDPOINTS } from '../../api/endpoints/services-orders.endpoints';

@Injectable({
  providedIn: 'root',
})
export class ServicesOrdersService {
  private api = inject(ApiService);

  getServicesOrdersByPage(query): Observable<any> {
    return this.api.get(SERVICES_ORDERS_ENDPOINTS.V1.SERVICES_ORDERS, query);
  }

  getServicesOrder(id): Observable<any> {
    return this.api.get<any>(
      SERVICES_ORDERS_ENDPOINTS.V1.NEW_SERVICES_ORDER(id),
    );
  }

  updateServicesOrder(id, order): Observable<any> {
    return this.api.put(
      SERVICES_ORDERS_ENDPOINTS.V1.NEW_SERVICES_ORDER(id),
      order,
    );
  }

  getNewStatus() {
    return this.api.get(SERVICES_ORDERS_ENDPOINTS.V1.NEW_ORDER_STATUS).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.errorHandler),
    );
  }

  getComponentByType(elemCategory, elemType) {
    if (elemCategory == 'input') {
      return InputsComponent;
    } else {
      switch (elemType) {
        case 'select':
          return SelectDynamicComponent;
        case 'multiselect':
          return MultiselectComponent;
        case 'files':
          return FilesComponent;
        case 'datepicker':
          return DateComponent;
        case 'date-range':
          return DateRangeComponent;
        case 'textarea':
          return TextareaComponent;
        case 'map':
          return DynamicMapComponent;
        case 'radio':
          return RadioBtnsComponent;
        case 'checkbox':
          return CheckboxBtnComponent;
        default:
          break;
      }
    }
  }

  changePaymentStatus(orderID) {
    return this.api.get<any>(
      SERVICES_ORDERS_ENDPOINTS.V1.CLIENT_PAYMENT_CAPTURE(orderID),
    );
  }

  changeProviderPayment(orderID, service) {
    return this.api.post(
      SERVICES_ORDERS_ENDPOINTS.V1.DELIVERED_PAYMENT_TO_PROVIDER(orderID),
      service,
    );
  }

  addFiles(orderId, fileType, files): Observable<any> {
    return null;
  }

  deleteFile(id): Observable<any> {
    return null;
  }

  updateZap(id) {
    return this.api.get(SERVICES_ORDERS_ENDPOINTS.V1.UPDATE_NEW_ORDER_ZAP(id));
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error.message || 'server error.');
  }
}
